export enum OtpNature {
	WEB_LOGIN = 6,
	WEB_FORGET_PWD = 7,
}

export enum SendType {
	EMAIL = 1,
	PHONE = 2,
}
